<template>
  <div class="about">
    <div class="grid-container">
      <div class="grid">
        <div class="quote">
          „Ich arbeite gern visuell und denke in Zusammenhängen. Mich interessiert, wie aus komplexen Inhalten klare,
          nachvollziehbare Formate werden.“
        </div>
        <div>
          <img class="img-fluid" alt="jan" src="@/assets/jan-roedger.jpg" />
        </div>

        <div class="copy">
          <h4>Über mich</h4>
          <p>
            Kommunikations- und Medienprofi mit über zehn Jahren Erfahrung – und einem klaren Anspruch: Inhalte müssen
            nicht nur funktionieren, sondern berühren.
          </p>
          <p>
            Ich entwickle audiovisuelle Formate, die komplexe Themen verständlich machen, ohne sie zu vereinfachen.
            Dokumentarisch gedacht, kinematografisch umgesetzt, immer nah an den Menschen, um die es geht.
          </p>
          <p>
            Ob große Struktur oder kleines Setting: Ich bewege mich sicher durch den gesamten Produktionsprozess und
            arbeite präzise, ruhig, lösungsorientiert und mit Humor – auch wenn es komplex wird.
          </p>
        </div>
        <div class="equipment">
          <h4>Kunden & Marken (Auswahl)</h4>
          <ul>
            <li>BASF</li>
            <li>BBC</li>
            <li>BDBOS</li>
            <li>Brand New Bundestag</li>
            <li>Deutsche Bank</li>
            <li>DFB</li>
            <li>Great Big Story</li>
            <li>Oxfam</li>
            <li>Opterra CRH</li>
            <li>Samsung</li>
            <li>Sound Innovation Lab</li>
            <li>TU Berlin</li>
            <li>Vodafone</li>
          </ul>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'About',
};
</script>

<style scoped lang="scss">
.grid {
  display: grid;
  grid-template-columns: 1fr;
  gap: 30px;

  @media (min-width: 768px) {
    grid-template-columns: repeat(2, 1fr);
  }
}

.quote {
  font-size: 1.5rem;
  font-style: italic;
  line-height: 1.5;
  align-self: center;
  text-align: center;
}

ul {
  list-style: none;
  padding: 0;
}
</style>
